import React from 'react'
import Header from '../../components/header'

const Copyright = () => {
  return (
    <div>
        <>
              <Header hideSearchBar={true} hideAddNew={true} hideHome={true} />

      CopyRight
      </>
    </div>
  )
}

export default Copyright
